<div class="albi-chat-container">
  <ng-container *ngIf="chat; else selectChatOrStartNew">
    <!-- Header -->
    <div class="albi-header">
      <button class="albi-back-btn" (click)="close()">
        <itl-alberta-icon name="arrow-back-outline"></itl-alberta-icon>
      </button>
      <div class="albi-header-avatar">
        <div class="albi-avatar-ring">
          <div class="albi-avatar-inner">
            <span class="albi-avatar-letter">A</span>
          </div>
        </div>
        <div class="albi-status-dot"></div>
      </div>
      <div class="albi-header-info">
        <span class="albi-header-name">Alberta AI</span>
        <span class="albi-header-subtitle" [class.albi-typing-pulse]="chat.isBotTyping">
          {{ chat.isBotTyping ? 'schreibt...' : 'KI-Assistent · Online' }}
        </span>
      </div>
    </div>

    <!-- Conversation -->
    <div class="albi-messages-scroll">
      <div class="albi-messages-inner">
        <!-- Welcome decoration -->
        <div class="albi-welcome-badge" *ngIf="chat.messages.length <= 1">
          <span>Heute</span>
        </div>

        <ng-container
          *ngFor="let message of chat.messages; let i = index; let first = first; let last = last; trackBy: trackByFn"
        >
          <!-- Date badge between messages from different days could go here -->

          <div
            class="albi-message-row"
            [class.albi-message-row--mine]="message.isMine"
            [class.albi-message-row--bot]="!message.isMine"
            [class.albi-message-row--close]="i > 0 && chat.messages[i - 1].isMine === message.isMine"
          >
            <!-- Bot avatar (only on first of a group) -->
            <div
              class="albi-bot-avatar"
              *ngIf="!message.isMine"
              [class.albi-bot-avatar--visible]="last || chat.messages[i + 1].isMine !== message.isMine"
            >
              <span>A</span>
            </div>

            <!-- Bubble -->
            <div
              class="albi-bubble"
              [class.albi-bubble--mine]="message.isMine"
              [class.albi-bubble--bot]="!message.isMine"
            >
              <!-- Message content -->
              <markdown class="albi-markdown" [data]="message.value"></markdown>

              <!-- Patient selection buttons -->
              <ng-container *ngIf="message.patients && message.patients.length > 0">
                <div class="albi-selection-list">
                  <button
                    *ngFor="let patient of message.patients"
                    class="albi-selection-btn"
                    (click)="selectPatient(message.id, patient)"
                  >
                    <div class="albi-selection-btn__icon">
                      <itl-alberta-icon name="person-outline"></itl-alberta-icon>
                    </div>
                    <div class="albi-selection-btn__content">
                      <span class="albi-selection-btn__title">{{ patient.firstName }} {{ patient.lastName }}</span>
                      <span class="albi-selection-btn__sub" *ngIf="patient.birthday">
                        {{ patient.birthday | date: 'dd.MM.yyyy' }}
                      </span>
                    </div>
                    <itl-alberta-icon
                      class="albi-selection-btn__arrow"
                      name="chevron-forward-outline"
                    ></itl-alberta-icon>
                  </button>
                </div>
              </ng-container>

              <!-- Integrated care selection buttons -->
              <ng-container *ngIf="message.integratedCares && message.integratedCares.length > 0">
                <div class="albi-selection-list">
                  <button
                    *ngFor="let care of message.integratedCares"
                    class="albi-selection-btn"
                    [style.--care-color]="care.color"
                    (click)="selectIntegratedCare(message.id, care)"
                  >
                    <div class="albi-selection-btn__icon" [style.color]="care.color">
                      <itl-alberta-icon [name]="care.iconName"></itl-alberta-icon>
                    </div>
                    <div class="albi-selection-btn__content">
                      <span class="albi-selection-btn__title">{{ care.therapyName }} ({{ care.therapyTypeName }})</span>
                      <span class="albi-selection-btn__sub" *ngIf="care.locationName">{{ care.locationName }}</span>
                    </div>
                    <itl-alberta-icon
                      class="albi-selection-btn__arrow"
                      name="chevron-forward-outline"
                    ></itl-alberta-icon>
                  </button>
                </div>
              </ng-container>

              <!-- Payer selection buttons -->
              <ng-container *ngIf="message.payers && message.payers.length > 0">
                <div class="albi-selection-list">
                  <button
                    *ngFor="let payer of message.payers"
                    class="albi-selection-btn"
                    (click)="selectPayer(message.id, payer)"
                  >
                    <div class="albi-selection-btn__icon">
                      <itl-alberta-icon name="card-outline"></itl-alberta-icon>
                    </div>
                    <div class="albi-selection-btn__content">
                      <span class="albi-selection-btn__title">{{ payer.name }}</span>
                      <span class="albi-selection-btn__sub" *ngIf="payer.ikNumber">IK: {{ payer.ikNumber }}</span>
                    </div>
                    <itl-alberta-icon
                      class="albi-selection-btn__arrow"
                      name="chevron-forward-outline"
                    ></itl-alberta-icon>
                  </button>
                </div>
              </ng-container>

              <!-- Timestamp -->
              <div
                class="albi-bubble__time"
                *ngIf="
                  first ||
                  last ||
                  chat.messages[i + 1].isMine !== message.isMine ||
                  chat.messages[i + 1].createdAt !== message.createdAt
                "
              >
                {{ message.createdAt | date: 'HH:mm' }}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Typing indicator -->
        <div class="albi-message-row albi-message-row--bot" *ngIf="chat.isBotTyping">
          <div class="albi-bot-avatar albi-bot-avatar--visible"><span>A</span></div>
          <div class="albi-bubble albi-bubble--bot albi-bubble--typing">
            <ng-container *ngIf="thinkingSteps.length > 0; else typingDots">
              <div class="albi-thinking-steps">
                <div
                  *ngFor="let step of thinkingSteps"
                  class="albi-thinking-step"
                  [class.albi-thinking-step--done]="step.status === 'done'"
                  [class.albi-thinking-step--running]="step.status === 'running'"
                >
                  <span class="albi-thinking-step__icon">{{ step.status === 'done' ? '✓' : '…' }}</span>
                  <span class="albi-thinking-step__label">{{ step.label }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #typingDots>
              <div class="albi-typing-dots">
                <div class="albi-dot"></div>
                <div class="albi-dot"></div>
                <div class="albi-dot"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Input area -->
    <div class="albi-input-area">
      <!-- Voice partial text -->
      <div class="albi-partial-text" *ngIf="partialText">
        <itl-alberta-icon name="mic-outline"></itl-alberta-icon>
        <span>{{ partialText }}</span>
      </div>
      <div class="albi-input-row">
        <div class="albi-input-wrapper">
          <textarea
            cdkTextareaAutosize
            #messageInput
            class="albi-textarea"
            placeholder="Nachricht an Albi..."
            (keydown)="handleEnter($event)"
          ></textarea>
        </div>
        <!-- Microphone button -->
        <button
          class="albi-action-btn albi-action-btn--mic"
          [class.albi-action-btn--listening]="isListening"
          (click)="toggleMic()"
        >
          <itl-alberta-icon [name]="isListening ? 'mic-off-outline' : 'mic-outline'"></itl-alberta-icon>
        </button>
        <!-- Send button -->
        <button class="albi-action-btn albi-action-btn--send" (click)="sendMessage()">
          <itl-alberta-icon name="alberta-fab-resend"></itl-alberta-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Select chat or start new template -->
  <ng-template #selectChatOrStartNew>
    <div class="flex flex-col flex-auto items-center justify-center bg-gray-100 dark:bg-transparent">
      <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">
        Select a conversation or start a new chat
      </div>
    </div>
  </ng-template>
</div>
